import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { useNavigation } from "@react-navigation/native";

import t from "@constants/localization";
import Notification from "@assets/svg/Notification";
import { colors } from "@constants/theme";
import { Rescheduled } from "@assets/svg/MyDeliveries";
import OnLeave from "@assets/svg/OnLeave";

import PaymentCard from "../DeliveryReturn/PaymentCard";

const PATH = "screens/MyDeliveries/components/NoUpdates";

function ListEmptyComponent({ deliveryState, ledger }) {
  const navigation = useNavigation();

  if (deliveryState === "Rescheduled") {
    return (
      <View style={styles.container}>
        <Rescheduled />
        <Text style={styles.text1}>{t(`${PATH}/rescheduled`)}</Text>
        <Text style={styles.text2}>{t(`${PATH}/rescheduleMsg`)}</Text>
        <Pressable
          testID="lec-upcoming-btn"
          style={{ alignItems: "center" }}
          onPress={() => navigation.navigate("upcoming")}
        >
          <Text style={styles.text2}>
            {t(`${PATH}/btnText1`)}
            <Text style={styles.nextSectionLink}> {t(`${PATH}/btnText`)}</Text>
            {t(`${PATH}/btnText2`)}
          </Text>
        </Pressable>
      </View>
    );
  } else if (deliveryState === "Vacationing") {
    return (
      <>
        {ledger ? (
          <PaymentCard ledger={ledger} showViewDetailsBtn={true} />
        ) : null}
        <View style={styles.container}>
          <OnLeave />
          <Text style={styles.text1}>{t(`${PATH}/onLeave`)}</Text>
          <Text style={styles.text2}>{t(`${PATH}/leaveDesc`)}</Text>
        </View>
      </>
    );
  }
  return (
    <View style={styles.container}>
      <Notification />
      <Text style={styles.text1}>{t(`${PATH}/title`)}</Text>
      <Text style={styles.text2}>{t(`${PATH}/desc`)}</Text>
    </View>
  );
}

export default ListEmptyComponent;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
    alignItems: "center",
    justifyContent: "center",
  },
  text1: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 27,
    textAlign: "center",
    color: colors.mediumBlack,
    marginTop: 16,
    marginBottom: 4,
  },
  text2: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    fontWeight: "400",
    lineHeight: 20,
    textAlign: "center",
    color: colors.lightBlack,
    maxWidth: "80%",
  },
  nextSectionLink: {
    textDecorationLine: "underline",
    color: colors.primary,
    fontFamily: "NotoSansDevanagari-Bold",
    textAlign: "center",
  },
});
